    import ContractStore from '../stores/ContractStore'
    import Web3Store from '../stores/Web3Store'

    export async function getOracleStatus() {
        let oracleStatus;
        oracleStatus = await ContractStore.call("OracleVerifier", "checkVerification", [Web3Store.account]);
        return oracleStatus;
    }



// WEBPACK FOOTER //
// ./src/contract/OracleVerifier.js